<template lang="pug">
section.row.search
  loader(v-if="!loaded")
  .search__app(v-else)
    .search__field
      .g
        .g__c.g__c__md10.g__c--lg8.g__c--noMargins
          SearchBox(@submitsearch="submitSearch")
    .search__container
      .search__main
        SearchFiltersTags(@submitfilters="submitFilters")
        template(v-for="result in results.itemResults")
          SearchResultDocument(
            :key="result.key", 
            :result="result")
        SearchPagination(
          v-if="settings.shouldHeaderBeShown",
          @submitpage="submitPage"
        )
</template>

<script>
import SearchFunctions from './mixins/SearchFunctions';
import SearchFiltersTags from './components/SearchFiltersTags';

export default {
  name: "SearchApp",
  components: {
    SearchFiltersTags,
  },
  mixins: [SearchFunctions],
  data() {
    return { };
  },
  computed: { },
  methods: { },
  created() {
    this.initialize();
  },
};
</script>

<style scoped lang="scss">
.search {
  display: flex;
  flex-direction: column;
  margin-top: 1.875rem;
  &__app {
    @include mq(lg) {
      & > .search__container {
        display: flex;
        & > .search__main,
        & > .search__rail {
          overflow: hidden;
          margin: 0 #{$gutter};
          &:nth-child(1) {
            margin-left: 0;
          }
          &:nth-child(2) {
            margin-right: 0;
          }
          &:only-child {
            margin: 0;
          }
        }
        & > .search__main {
          flex: 0 1 calc(100% - #{$gutter});
        }

        & > .search__rail {
          flex: 1 0 calc(13.75rem + #{$gutter});
          min-width: calc(13.75rem + #{$gutter});
          max-width: calc(13.75rem + #{$gutter});
        }
      }
    }
  }
}
</style>